module.exports = __webpack_public_path__ + "img/number-black-26.aee303e3.png";